import '../../vendor/clickmenu.js';

const syncMobileMenuInert = ($nav: JQuery<HTMLElement>): void => {
  const menuToggleId = $nav.find('[data-menu-toggle]').attr('data-menu-toggle');
  if (!menuToggleId) return;

  const $menuDrop = $nav.find(`[data-menu-drop="${menuToggleId}"]`);
  if ($menuDrop.length === 0) return;

  const mediaQuery = window.matchMedia('(min-width: 60em)');
  const syncDesktopInert = (): void => {
    if (mediaQuery.matches) {
      $menuDrop.removeAttr('inert');
    }
  };

  syncDesktopInert();
  mediaQuery.addEventListener('change', syncDesktopInert);

  $nav.on('afterMenuShow', () => {
    $menuDrop.removeAttr('inert');
  });

  $nav.on('afterMenuHide', () => {
    if (!mediaQuery.matches) {
      $menuDrop.attr('inert', '');
    }
  });
};

type NavWithClickMenu = HTMLElement & { clickMenu?: { destroy: () => void } };

export const setupNavigation = (): void => {
  $('.nav-menu').each(function initNavMenu(this: NavWithClickMenu) {
    const $nav = $(this);
    if (this.clickMenu?.destroy) {
      this.clickMenu.destroy();
    }
    $nav.clickMenu({ expanders: false, landings: false });
    syncMobileMenuInert($nav);
  });

  $('.nav-rail').clickMenu({ menutype: 'accordion', expanders: true });

  $('.nav-toggle').on('click', function onNavToggle(this: HTMLElement) {
    $(this).toggleClass('active');
  });

  $('.toggle-menu span').on('click', () => {
    $('.toggle-menu').attr('aria-expanded', (_i, v) => (v === 'false' ? 'true' : 'false'));
  });
};
